let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lseqR")).then(() => parcelRequire('3Nhdd'));